import {
  doc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Save_phonebook_edit = async (data) => {
  const { uid, category, mobilenumber } = data || {};

  // 1. Validate inputs
  if (!uid?.trim()) {
    return { success: false, error: "Missing uid for update." };
  }
  if (!category?.trim()) {
    return { success: false, error: "Missing category." };
  }
  if (!mobilenumber?.trim()) {
    return { success: false, error: "Missing mobile number." };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || sessiontoken === "undefined") {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid || guid === "undefined") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const tablename = "phonebook";

    // ✅ Verify record exists for this uid & guid
    const phonebookQuery = query(
      collection(db, tablename),
      where("uid", "==", uid),
      where("guid", "==", guid)
    );
    const snapshot = await getDocs(phonebookQuery);

    if (snapshot.empty) {
      return { success: false, error: "Record not found for update." };
    }

    // ✅ Update parent document
    const parentDocRef = doc(db, tablename, uid);
    await updateDoc(parentDocRef, {
      category,
      sessiontoken,
      date_time_update: new Date(),
    });

    // ✅ Update fields subcollection
    const fieldsCollection = collection(parentDocRef, "fields");
    for (const [fieldName, fieldValue] of Object.entries(data)) {
      if (
        !fieldValue ||
        fieldName === "uid" ||
        fieldName === "category"
      ) {
        continue;
      }

      // check if field already exists
      const existingFields = await getDocs(
        query(fieldsCollection, where("fieldName", "==", fieldName))
      );

      if (!existingFields.empty) {
        // update existing field
        for (const fieldDoc of existingFields.docs) {
          await updateDoc(fieldDoc.ref, {
            fieldValue,
            sessiontoken,
          });
        }
       
       } else {
   
        const docid = Randomcode(22);
        const savedata = {
          docid,
          uid,
          guid,
          sessiontoken,
          fieldName,
          fieldValue,
        };
        const fieldDocRef = doc(fieldsCollection, docid);
        await setDoc(fieldDocRef, savedata);
      }
    }

    return { success: true };
  } catch (err) {
    console.error("❌ Error updating document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
